import filterHelpers from '../../views/filter/helpers';

export default {
  updateActiveFilter({ getters, commit }) {
    const currentFilter = getters.currentFilter;

    const updatedData = {
      type: currentFilter.type,
      filter: currentFilter.properties,
    };

    if (currentFilter.project_id) {
      updatedData.project_id = currentFilter.project_id;
    }

    commit('setActiveFilters', updatedData);
  },
  resetFilter({ getters, dispatch, commit }) {
    const emptyProperties = filterHelpers.getEmptyFilter();

    commit('updateCurrentFilter', { id: null, name: null, properties: emptyProperties });
  },
};
